import React, { useState, useEffect, useContext, useRef } from 'react';
import './ProcessChanges.css';
import OrganizationRow from './OrganizationRow';
import InteractiveList from '../InteractiveList/InteractiveList';
import { AdminContext } from '../../contexts/AdminContext';
import logComponent from '../../common/logComponent';

export default function ProcessChanges({ isLoading, isError, reload, showOrganizationDetail }) {
  const adminContext = useContext(AdminContext);
  const { stagedOrganizations } = adminContext;

  if (logComponent('ProcessChanges')) { console.debug('ProcessChanges rendered'); }

  return (
    <div className="Process-Changes">

      <InteractiveList
        columns={[
          { name: 'Name', sortField: 'Name' },
          { name: 'Type', style: { width: '20%' }, hideAt: 'md-below' },
          { name: 'Status', style: { width: '20%' } },
          { name: '', style: { width: '64px' } }
        ]}
        searchTextFields={['Name', 'PostalCode', 'SalesforceSiteId']}
        searchPlaceholder="Search facility or corporate group"
        defaultSortField="Name"
        filters={[
          {
            title: 'Also uses',
            type: 'checkbox',
            name: 'servicesUsed',
            options: [
              {
                text: 'CATIE',
                criteria: [{
                  field: 'UsingCatie',
                  acceptedValues: [true]
                }]
              },
              {
                text: 'eMessenger',
                criteria: [{
                  field: 'UsingEMessenger',
                  acceptedValues: [true]
                }]
              },
              {
                text: 'SARA',
                criteria: [{
                  field: 'UsingSara',
                  acceptedValues: [true]
                }]
              }
            ]
          },
          {
            title: 'Entity type',
            type: 'checkbox',
            name: 'entityType',
            options: [
              {
                text: 'Corporation',
                criteria: [{
                  field: 'uiData.type',
                  acceptedValues: ['corporation']
                }]
              },
              {
                text: 'Facility',
                criteria: [{
                  field: 'uiData.type',
                  acceptedValues: ['facility']
                }]
              }
            ]
          },
          {
            title: 'Industry type',
            type: 'checkbox',
            name: 'industryType',
            options: [
              {
                text: 'CCRC',
                criteria: [{
                  field: 'IndustryType',
                  acceptedValues: ['CCRC']
                }]
              },
              {
                text: 'Long Term Care',
                criteria: [{
                  field: 'IndustryType',
                  acceptedValues: ['Long Term Care']
                }]
              },
              {
                text: 'Healthcare',
                criteria: [{
                  field: 'IndustryType',
                  acceptedValues: ['Healthcare']
                }]
              },
              {
                text: 'Hotel/Hospitality',
                criteria: [{
                  field: 'IndustryType',
                  acceptedValues: ['Hotel/Hospitality']
                }]
              },
              {
                text: 'Government',
                criteria: [{
                  field: 'IndustryType',
                  acceptedValues: ['Government']
                }]
              },
              {
                text: 'Education',
                criteria: [{
                  field: 'IndustryType',
                  acceptedValues: ['Education']
                }]
              }
            ]
          },
          {
            title: 'Status',
            type: 'checkbox',
            name: 'status',
            options: [
              {
                text: 'New',
                criteria: [{
                  field: 'uiData.status',
                  acceptedValues: ['new']
                }]
              },
              {
                text: 'Updated',
                criteria: [{
                  field: 'uiData.status',
                  acceptedValues: ['updated']
                }]
              },
              {
                text: 'Rejected',
                criteria: [{
                  field: 'uiData.status',
                  acceptedValues: ['rejected']
                }]
              }
            ]
          }
        ]}
        singularItemTerm="organization"
        pluralItemTerm="organizations"
        items={stagedOrganizations}
        itemsLoading={isLoading}
        itemsError={isError}
        rowComponent={OrganizationRow}
        showDetail={showOrganizationDetail}
        keyField="salesforceAccountId"
        reloadAction={reload} />
    </div>
  );
}